import { MapboxPlaceObject } from '../../types/mapbox/MapboxPlaceObject';
import { MapboxPlaceType } from '../../types/MapboxPlaceType';

export function isPlace(mapboxPlaceObject: MapboxPlaceObject) {
  return mapboxPlaceObject.place_type.some(x => x === MapboxPlaceType.Place);
}
